module.exports = __webpack_public_path__ + "img/20.26aecc93.png";